<template>
  <div class="header">
    <invoice-type v-model:code="listQuery.fplxdm"></invoice-type>
    <el-button :loading="loading" type="primary" size="mini" @click="search" style="margin-left:4px">查询</el-button>
  </div>
  <div class="home">
    <el-table ref="singleTable" :data="tableData" highlight-current-row border @current-change="handleCurrentChange" style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}" size="mini">
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
      <!-- <el-table-column property="fplxdm" label="发票类型代码" width="100" align="center"></el-table-column> -->
      <el-table-column label="发票类型" width="160" align="center">
        <template v-slot="scope">
          <span>{{ $fplx(scope.row.fplxdm) }}</span>
        </template>
      </el-table-column>
      <el-table-column property="fpzldm" label="发票种类代码" width="100" align="center"></el-table-column>
      <el-table-column property="slxh" label="申领序号" width="250" align="center"> </el-table-column>
      <el-table-column property="slsl" label="申领数量" align="center"> </el-table-column>
      <el-table-column property="slsj" label="申领时间" width="120" align="center"></el-table-column>
      <el-table-column property="clzt" label="处理状态" width="70" align="center"></el-table-column>
      <el-table-column property="clxx" label="处理信息" align="center"> </el-table-column>
      <el-table-column property="clsj" label="处理时间" align="center"> </el-table-column>
      <el-table-column property="ysqbh" label="预申请编号" align="center"> </el-table-column>
      <el-table-column property="jgqrbz" label="结果确认标志" align="center"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template #default="scope">
          <el-button @click="cancelApply(scope.row)" type="text" size="small">撤销</el-button>
          <el-button v-if="scope.row.fplxdm != '026' && scope.row.fplxdm != '028'" @click="confirmApply(scope.row)" type="text" size="small">确认</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { applyInvoiceStatus, cancelApplyInvoice,applyInvoiceQz } from "@/api/apply";
export default {
  name: 'InvoiceApplyStatus',
  created () {
    
  },
  data(){
    return {
      loading: false,
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
        fplxdm: '',
      },
      tableData: [],
    }
  },
  methods:{
    search(){
      if(this.listQuery.fplxdm == ""){
        this.$qzfMessage("请选择发票类型", 1)
        return
      }
      this.getList()
    },
    confirmApply(row){
      this.$confirm('确定接收?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          comId: this.$store.getters['user/comInfo'].id*1,
          fplxdm: row.fplxdm,
          slxh: row.slxh,
          fpdm: row.fpdm,
          qshm: row.qshm,
          zzhm: row.zzhm,
          fs: row.fs,
        }
        applyInvoiceQz(param).then(res=>{
          if(res.data.msg == "success"){
            this.getList()
            this.$qzfMessage("已确认")
          }
        })
      })
    },
    cancelApply(row){
      this.$confirm('确定撤销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          comId: this.$store.getters['user/comInfo'].id*1,
          fplxdm: row.fplxdm,
          slxh: row.slxh,
        }
        cancelApplyInvoice(param).then(res=>{
          if(res.data.msg == "success"){
            this.getList()
            this.$qzfMessage("撤销成功")
          }
        })
      })
    },
    //获取列表
    getList(){
      this.loading = true
      applyInvoiceStatus(this.listQuery).then(res=>{
        this.loading = false
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.header{
  padding: 10px 10px 10px 10px;
}
</style>